import { Component, Input } from '@angular/core';
import { FormGroup, FormArray } from '@angular/forms';

@Component({
  selector: 'app-preview-project',
  templateUrl: './preview-project.component.html'
})
export class PreviewProjectComponent {
  @Input() projectForm!: FormGroup;
  @Input() budgets!: FormArray;

  getCategoryName(categoryId: string): string {
    const categories = this.projectForm.get('categories')?.value || [];
    const category = categories.find((cat: any) => cat.id === categoryId);
    return category ? category.name : 'Categoría Desconocida';
  }

  getSubcategoryName(subcategoryId: string): string {
    const subcategories = this.projectForm.get('subcategories')?.value || [];
    const subcategory = subcategories.find((sub: any) => sub.id === subcategoryId);
    return subcategory ? subcategory.name : 'Subcategoría Desconocida';
  }

  getStatusLabel(status: string): string {
    const statuses: Record<string, string> = { active: 'Activo', inactive: 'Inactivo' };
    return statuses[status] || 'Desconocido';
  }

  getProjectTypeLabel(type: string): string {
    const types: Record<string, string> = { internal: 'Interno', external: 'Externo' };
    return types[type] || 'Desconocido';
  }
}
